// Mock data for CoolTrace Solutions landing page clone (frontend-only)

export const PHONE = '+44 7522 091790';
export const PHONE_HREF = 'tel:+447522091790';

export const NAV_LINKS = [
  { label: 'Response', href: '#response' },
  { label: 'Chapters', href: '#chapters' },
  { label: 'Coverage', href: '#coverage' },
  { label: 'FAQ', href: '#faq' },
  { label: 'Request Callout', href: '#request' },
];

export const HERO_STATS = [
  { value: '\u2264 60m', label: 'Avg. response, Zone 1\u20134' },
  { value: '24/7', label: 'Every night, weekend, bank holiday' },
  { value: 'F-Gas', label: 'Certified engineers only' },
];

export const MARQUEE_ITEMS = [
  'Emergency AC Callouts',
  'London 24/7',
  'F-Gas Certified',
  'Split \u00b7 VRV \u00b7 VRF \u00b7 Chillers',
  'Response \u2264 60 min \u00b7 Zones 1\u20134',
  'Commercial \u00b7 Residential \u00b7 Server Rooms',
];

export const CHAPTERS = [
  {
    num: '01',
    kicker: 'The Callout',
    title: 'One call. One engineer. One clear plan.',
    body: "You reach a human \u2014 not a queue. In under three minutes we've triaged the unit, symptom, and postcode, and dispatched the nearest engineer with the right refrigerant on board.",
    signalValue: '\u2264 3m',
    signalLabel: 'From ring to dispatch',
  },
  {
    num: '02',
    kicker: 'On Site',
    title: 'Diagnosis before repair, always.',
    body: 'We pressure-test, thermal-image, and read live pressures before we quote a part. If it can be fixed cold in one visit, it is. If it needs staging, you get a fixed price before we open a wallet.',
    signalValue: '84%',
    signalLabel: 'First-visit resolutions',
  },
  {
    num: '03',
    kicker: 'The Aftermath',
    title: 'A record, not a receipt.',
    body: 'Every callout ends with a written diagnostic \u2014 photographs, refrigerant logs, F-Gas compliance notes. Landlords, facilities managers, and insurers get exactly what they need to sign off.',
    signalValue: 'F-Gas',
    signalLabel: 'Fully compliant paperwork',
  },
  {
    num: '04',
    kicker: 'The Promise',
    title: 'Warm quotes. Cold rooms. No small print.',
    body: 'Callout fee is disclosed on the phone. Weekend, weeknight, or 04:00 \u2014 the number you\u2019re told is the number you pay. No priority tiers, no ghost surcharges.',
    signalValue: '\u00a30',
    signalLabel: 'Hidden fees, ever',
  },
];

export const TIMELINE = [
  { time: 'T+00:00', num: '01', title: 'You ring +44 7522 091790', body: 'A live engineer picks up \u2014 no queue, no bots.' },
  { time: 'T+00:03', num: '02', title: 'Triage & dispatch', body: 'Symptom, unit, postcode logged. Nearest van rolls with the right refrigerant.' },
  { time: 'T+00:45', num: '03', title: 'Boots on tiles', body: 'Average zone-1 arrival window. Diagnostics start immediately.' },
  { time: 'T+01:30', num: '04', title: 'Cold air, on record', body: '84% of callouts resolved on visit one \u2014 with a full written report.' },
];

export const CREDENTIALS = [
  'F-Gas Category I certified across all callout engineers',
  'Public liability insured to \u00a35m',
  'Refcom & CIPHE registered \u00b7 TrustMark accredited',
  'REFCOM \u00b7 Safe Contractor \u00b7 Constructionline Gold',
];

export const COVERAGE_STATS = [
  { value: '4', label: 'Depots' },
  { value: '18', label: 'Vans on rota' },
  { value: '26', label: 'Engineers' },
  { value: '42m', label: 'Avg. ETA \u00b7 Z1' },
];

export const BOROUGHS = [
  'City of London', 'Westminster', 'Camden', 'Islington', 'Hackney', 'Tower Hamlets',
  'Southwark', 'Lambeth', 'Wandsworth', 'Hammersmith & Fulham', 'Kensington & Chelsea',
  'Newham', 'Greenwich', 'Lewisham', 'Waltham Forest', 'Haringey', 'Brent', 'Ealing',
  'Hounslow', 'Richmond upon Thames', 'Kingston', 'Merton', 'Sutton', 'Croydon',
  'Bromley', 'Bexley', 'Havering', 'Redbridge', 'Barking & Dagenham', 'Enfield',
  'Barnet', 'Harrow', 'Hillingdon',
];

export const FORM_STEPS = [
  { n: '01', text: 'A ring back within 5 minutes to confirm access.' },
  { n: '02', text: 'Fixed callout fee agreed on the phone \u2014 no surprises.' },
  { n: '03', text: 'Engineer on-site with parts and a printed report.' },
];

export const PROPERTY_TYPES = ['Residential', 'Commercial', 'Server Room / Data'];
export const URGENCY_TYPES = ['ASAP \u00b7 Emergency', 'Today', 'Tomorrow'];

export const FAQS = [
  {
    q: 'How fast can you actually get to me?',
    a: 'Across Zones 1\u20134 our average on-site window is under 60 minutes, day or night. The moment you ring, the nearest van is dispatched \u2014 we\u2019ll give you a realistic ETA on the call, not a four-hour window.',
  },
  {
    q: "What's the callout fee?",
    a: 'The callout fee is fixed and disclosed on the phone before we roll \u2014 weekend, weeknight or 04:00. There are no priority tiers and no ghost surcharges. The number you\u2019re told is the number you pay.',
  },
  {
    q: 'Do you cover residential AC too?',
    a: 'Yes. Split systems, multi-splits and portable units for homes and flats, alongside our commercial and server-room work. Same engineers, same response promise.',
  },
  {
    q: 'Server room down \u2014 can you prioritise?',
    a: 'Absolutely. Data and server rooms are flagged as priority the moment you call. We carry temporary cooling and the right refrigerant to stabilise temperatures fast while we diagnose.',
  },
  {
    q: 'Do you do the paperwork for insurers and landlords?',
    a: 'Every callout ends with a written diagnostic \u2014 photographs, refrigerant logs and F-Gas compliance notes \u2014 formatted so landlords, facilities managers and insurers can sign off without chasing.',
  },
];

export const FOOTER = {
  contact: [
    { text: 'info@cooltracesolutions.co.uk' },
    { text: 'Greater London \u00b7 All 33 boroughs' },
  ],
  services: ['Emergency Callout', 'Server Room \u00b7 Priority', 'Split \u00b7 VRV \u00b7 VRF', 'Landlord Reports'],
  legal: ['F-Gas Cert. #FG-2916', 'Refcom Registered', 'PLI \u00b7 \u00a35m Aviva', 'Constructionline Gold'],
};

export const IMAGES = {
  heroAlley: 'https://images.pexels.com/photos/30962631/pexels-photo-30962631.jpeg?auto=compress&cs=tinysrgb&w=900',
  circuit: 'https://images.pexels.com/photos/34054470/pexels-photo-34054470.jpeg?auto=compress&cs=tinysrgb&w=900',
  credentials: 'https://images.unsplash.com/photo-1513026705753-bc3fffca8bf4?auto=format&fit=crop&w=1900&q=80',
  cityAerial: 'https://images.unsplash.com/photo-1533929736458-ca588d08c8be?auto=format&fit=crop&w=1900&q=80',
};
